<script>
    export let image, size, title

		function imageClass(image) {
				image = image.replaceAll('.', '-')

				let data = image.split('/')
				return  data[data.length - 2] + '-' + data[data.length - 1]
		}
</script>

<div data-variant={imageClass(image)} class="item" on:click>
  {#if title}
  <h6>{title}</h6>
  {/if}
  <picture>
    <img src={image} class="{imageClass(image)}" alt="" >
    {#each size as size}		
      <i>{size} мм</i>
    {/each}
  </picture>
</div>


<style lang="scss">

  	h6 {
		text-align: center;
		font-size: 16px;
		font-weight: normal;
		line-height: 115%;
		padding: 0;
		margin: 0 0 20px;
	 }
  .item {
		
			width: 100%;
			padding: 15px;
			box-sizing: border-box;
			position: relative;

			picture {
				text-align: center;
				display: block;
				height: 240px;
				position: relative;

        @media (max-width: 768px) {
          height: auto;
          padding-bottom: 20px;
        }

				i {
					position: absolute;
					width: 100%;
					text-align: center;
					z-index: 2;
					font-weight: 600;
					color: #666;
					font-size: 13px;
				}

				i:nth-child(2){
						top: 155px;
						left: 0;
				}			

				i:nth-child(3){
					transform: rotate(268deg);
					left: -35px;
					top: 60px;
					width: 150px;
				}			

			}

			&[data-variant='img-3st-png']{
				  i:nth-child(3){
						left: -73px;
				  }		
			}

			&[data-variant='img-b-png']{
				  i:nth-child(3){
						left: -75px;
						top: 99px;
				  }		
			}	
			
			&[data-variant='img-b-png']{
				  i:nth-child(2){
						left: 0;
    				width: 120px;
						top: 238px;
				  }		
			}			
			
			&[data-variant='img-b-png']{
				  i:nth-child(4){
						left: 0;
    				top: -18px;
				  }		

				  i:nth-child(5){
						left: 180px;
    				top: 67px;
						transform: rotate(269deg);
					width: 150px;
				  }						
			}				


		}
	
	
	img.img-2st-png{
			height: 150px;
	}
	img.img-3st-png{
		height: 150px;
	}
	img.img-b-png{
		height: 240px;
	}	
</style>